import React from 'react'
import { connect } from 'react-redux'

require('./style.less')

@connect(state => ({ 
  dimensions: state.UI.dimensions
}))
export default class DimensionsZone extends React.Component {
  
  render() {
    const { dimensions } = this.props
    const { availableWidth, availableHeight, centerHeight, centerWidth, centerXOffset, centerYOffset } = dimensions

    return (
      <div className="dimensionsZones">
        <div className="zone available" style={{ width: `${availableWidth}px`, height: `${availableHeight}px` }}>
          <h1>AvailableBox: availableWidth: {availableWidth} availableHeight: {availableHeight}</h1>
        </div>
        <div className="zone center" style={{ top: `${centerYOffset}px`, left: `${centerXOffset}px`, width: `${centerWidth}px`, height: `${centerHeight}px` }}>
           <h1>CenterBox<br/>centerWidth:{centerWidth}<br/>centerHeight: {centerHeight}<br/>centerXOffset: {centerXOffset}<br/>centerYOffset: {centerYOffset}</h1>
        </div>
    </div>
    )
  }
}
